export default __webpack_public_path__ + "static/media/en_Wall.89171b0f.png";